<template>
  <div class="App">
    <Modal
      v-if="Modal"
      :Titulo="Titulo"
      :Texto="Texto"
      :Color="Color"
      @Aceptar="Aceptar"
    />
    <form v-on:submit.prevent="SendConfirms" class="Container">
      <h1>egep</h1>
      <h3>Consultores</h3>
      <p>Enter verification pin</p>
      <div class="input">
        <input
          type="text"
          id="pin1"
          name="pin1"
          maxlength="1"
          size="1"
          v-on:keyup="oprimir1"
          v-model="pin1"
          required
        />
        <input
          type="text"
          id="pin2"
          name="pin2"
          maxlength="1"
          size="1"
          v-model="pin2"
          v-on:keyup="oprimir2"
          required
        />
        <input
          type="text"
          id="pin3"
          name="pin3"
          maxlength="1"
          size="1"
          v-model="pin3"
          v-on:keyup="oprimir3"
          required
        />
        <input
          type="text"
          id="pin4"
          name="pin4"
          maxlength="1"
          size="1"
          v-model="pin4"
          v-on:keyup="oprimir4"
          required
        />
      </div>

      <button type="submit">CHECK</button>
      <a href="http://localhost:8080/RecoverPassword"
        >Return to email recovery</a
      >
    </form>
  </div>
</template>
<script>
import Modal from "../../components/Modal.vue";
export default {
  data: () => ({
    pin1: "",
    pin2: "",
    pin3: "",
    pin4: "",
    check: false,
    Modal: false,
    Titulo: "Error",
    Texto: "This code are incorrect, please check and try again",
    Color: "background: red;",
  }),
  methods: {
    oprimir1: function () {
      if (this.pin1.length == 1) {
        document.getElementById("pin2").focus();
      } else {
        document.getElementById("pin1").focus();
      }
    },
    oprimir2: function () {
      if (this.pin2.length == 1) {
        document.getElementById("pin3").focus();
      } else {
        document.getElementById("pin1").focus();
      }
    },
    oprimir3: function () {
      if (this.pin3.length == 1) {
        document.getElementById("pin4").focus();
      } else {
        document.getElementById("pin2").focus();
      }
    },
    oprimir4: function () {
      if (this.pin4.length == 1) {
        document.getElementById("pin4").focus();
      } else {
        document.getElementById("pin3").focus();
      }
    },
    SendConfirms() {
      console.log("Funciona el boton");
      if (
        this.pin1 == "" ||
        this.pin2 == "" ||
        this.pin3 == "" ||
        this.pin4 == ""
      ) {
        this.Modal = true;
      } else {
        this.$emit("ListenChildrenPassword", this.check);
      }
    },
    Aceptar() {
      this.Modal = false;
    },
  },
  components: { Modal },
};
</script>
<style lang="css" scoped>
.Container {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
  justify-content: center;
  align-items: center;
  width: 50vw;
}
.input {
  width: 100%;
  color: var(--second-color);
}
.Container input {
  margin: 1rem;
  height: 5rem;
  width: 4rem;
  border: none;
  background: var(--dark-firts-color);
  color: var(--second-color);
  border-radius: 15px;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  outline: none;
  text-align: center;
  font-size: 2rem;
}

.Container input::placeholder {
  color: var(--second-color);
  font-family: Poppins, Regular;
}
.icono {
  position: absolute;
  pointer-events: none;
  color: var(--second-color);
  font-size: 1.5rem;
  margin: 25px;
  margin-left: 30px !important;
}
.Container p {
  margin-bottom: 20pt;
  font-size: 40pt;
  color: var(--eleventh-color);
  font-family: "Poppins", sans-serif;
  font-weight: 300;
}
.Container a {
  text-decoration: none;
  color: var(--dark-third-color);
  width: 100%;
  text-align: center;
  margin-right: -150px;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  width: 200px;
}
.Container button {
  background: var(--firts-color);
  width: 350px;
  margin: 1rem;
  height: 2.7rem;
  border: none;
  border-radius: 15px;
  color: var(--second-color);
  font-size: 20px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  text-align: center;
}

.Container h1 {
  display: none;
}
.Container h3 {
  display: none;
}
.Container span {
  display: none;
}

@media (max-width: 1200px) {
  .Container p {
    font-size: 20pt;
  }
}
@media (max-width: 800px) {
  .Container {
    color: var(--second-color);
    justify-content: flex-end;
    width: 100vw;
  }
  .Container p {
    font-size: 1.5rem;
    color: var(--second-color);
  }
  .Container h1 {
    display: block;
    font-size: 100px;
    text-align: center;
    margin: 5px;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
    margin-bottom: -20px;
  }
  .Container h3 {
    display: block;
    font-size: 42px;
    margin: 5px;
    text-align: center;
    color: var(--sixth-color);
    font-family: "glacial-indifference", sans-serif;
    font-weight: 500;
  }
  .Container a {
    color: var(--second-color);
    margin-bottom: 80px;
    margin-right: -120px;
  }
  .Container span {
    display: block;
    margin: 10%;
    font-size: 1.5rem;
    text-align: center;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
  }
  .Container input {
    background: var(--second-color);
    color: var(--dark-firts-color);
    margin: 10px;
    height: 80px;
  }
  .Container button {
    margin-bottom: 10px;
    width: 315px;
  }
}
@media (max-width: 344px) {
  .Container button {
    margin-bottom: 10px;
    width: 270px;
  }
  .Container input {
    margin: 5px;
    height: 70px;
    width: 60px;
    border-radius: 15px;
  }
  .Container a {
    color: var(--second-color);
    margin-bottom: 80px;
    margin-right: -70px;
  }
}
</style>